export default "__VITE_ASSET__ZT4thKNO__"